<script setup>
import Hospital from "./td/Hospital.vue";
import TransportTerminateButton from "./td/actions/TransportTerminateButton.vue";
import TransportSelectButton from "./td/actions/TransportSelectButton.vue";
import Status from "./td/Status.vue";
import {priorityClass, unitType, ventilated} from "../../utils";
import {HospitalTypeLabel, PriorityLabel} from "../../choices";
import {GenderLabel} from "../../../../choices";
import {mdiGestureTap} from "@mdi/js";
import {pgettext} from "../../../../utils/translate";

const props = defineProps({
    patient: {
        type: Object,
        required: true
    },
    member: {
        type: Object,
        required: true
    },
    alertList: {
        type: Array,
        required: true
    },
    now: {
        type: Object,
        required: true
    },
})
const emit = defineEmits(['setEditedTransportData', 'openReplyModal', 'displayActionsModal'])
const alertType = props.patient.alertType

function handleSetEditedTransportData(patient) {
    emit('setEditedTransportData', patient)
}

function handleOpenReplyModal(data, patient) {
    emit('openReplyModal', data, patient)
}

function displayActionsModal() {
    emit('displayActionsModal', props.patient)
}


</script>

<template>
    <tr :key="patient.id">
        <td class="hpo-patients-list__td__buttons">
            <v-btn class="text-wrap w-auto"
                   :prepend-icon="mdiGestureTap"
                   @click="displayActionsModal">
                <span class="text-wrap">{{ pgettext('label', 'Options') }}</span>
            </v-btn>
            <TransportSelectButton :member="member"
                                   :patient="patient"
                                   @setEditedTransportData="handleSetEditedTransportData"/>
            <TransportTerminateButton :member="member"
                                      :patient="patient"
                                      @openReplyModal="handleOpenReplyModal"/>
        </td>

        <td class="hpo-tic">
            {{ patient.ticPrefix }}{{ patient.ticNumber }}
        </td>
        <td>
            <span>{{ GenderLabel[patient.gender] }}</span>
            <span v-if="patient.isChild">
                {{ ' (' }}{{ gettext('child').toUpperCase() }}{{ ')' }}
            </span>
        </td>
        <td class="hpo-priority" :class="priorityClass(patient.transportPriority)">
            {{ PriorityLabel[patient.transportPriority] }}
        </td>
        <td><div style="max-width: 150px">{{ patient.diagnose }}</div></td>
        <td>{{ ventilated(patient.ventilated) }}</td>
        <td>{{ unitType(patient.unitType, patient.unitTypeSpec) }}</td>
        <td>{{ patient.callSign }}</td>
        <td>{{ HospitalTypeLabel[patient.hospitalType] }}</td>

        <td>
            <Hospital :patient="patient"
                      :member="member"
                      :now="now"
                      @setEditedTransportData="handleSetEditedTransportData"
                      @openReplyModal="handleOpenReplyModal"/>
        </td>

        <td>
            <Status :patient="patient"
                    :member="member"
                    :alertList="alertList"/>
        </td>

    </tr>
</template>

<style scoped>
td {
    padding: 0 2px !important;
    text-align: center !important;
}
</style>
